import { baseApi } from '@api/baseApi';
import { GenericResult } from '@api/shared-types/GenericResult';
import { OrderReason, MaterialReason, SaveOrderReason, SaveMaterialReason } from '@api/order-reporting/types/reasonTypes';



const reasonApi = baseApi.injectEndpoints({
	overrideExisting: false,
	endpoints: (builder) => ({

		saveOrderPlanningReason: builder.mutation<GenericResult<OrderReason>,SaveOrderReason>({
			query: ({ unversionedSystemId, reasonCode }) => ({
				url: 'OrderReporting/SaveOrderPlanningReason',
				method: 'POST',
				body: { unversionedSystemId, reasonCode }
			}),
		}),

		saveOrderExecutionReason: builder.mutation<GenericResult<OrderReason>,SaveOrderReason>({
			query: ({ unversionedSystemId, reasonCode }) => ({
				url: 'OrderReporting/SaveOrderExecutionReason',
				method: 'POST',
				body: { unversionedSystemId, reasonCode }
			}),
		}),

		
		saveMaterialPlanningReason: builder.mutation<GenericResult<MaterialReason>,SaveMaterialReason>({
			query: ({ unversionedOrderSystemId, materialSystemId, reasonCode }) => ({
				url: 'OrderReporting/SaveOrderMaterialPlanningReason',
				method: 'POST',
				body: { unversionedOrderSystemId, materialSystemId, reasonCode }
			}),
		}),

		saveMaterialExecutionReason: builder.mutation<GenericResult<MaterialReason>,SaveMaterialReason>({
			query: ({ unversionedOrderSystemId, materialSystemId, reasonCode }) => ({
				url: 'OrderReporting/SaveOrderMaterialExecutionReason',
				method: 'POST',
				body: { unversionedOrderSystemId, materialSystemId, reasonCode }
			}),
		}),
	}),
});


export const { 
	useSaveOrderPlanningReasonMutation,
	useSaveOrderExecutionReasonMutation,
	useSaveMaterialPlanningReasonMutation,
	useSaveMaterialExecutionReasonMutation } = reasonApi;